function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useRef, useState, useEffect } from 'react';
import { Badge } from 'components/Badge/Badge';
import { CloseIcon } from 'components/Icon';
import * as S from './Tag.styles';
const Tag = /*#__PURE__*/React.forwardRef(({
  ariaLabel,
  content,
  contentText,
  numberBadgeAmount,
  disabled = false,
  readOnly = true,
  dismissable = false,
  size = 'medium',
  value,
  onDismiss,
  ...props
}, ref) => {
  const containerRef = useRef(null);
  const [isActionFocused, setIsActionFocused] = useState(false);
  const [isDismissHover, setIsDismissHover] = useState(false);
  const [isDismissActive, setIsDismissActive] = useState(false);
  useEffect(() => {
    const handleClickOutside = e => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsDismissHover(false);
        setIsDismissActive(false);
      }
    };
    document.addEventListener('pointerup', handleClickOutside);
    return () => {
      document.removeEventListener('pointerup', handleClickOutside);
    };
  }, []);
  const renderContent = () => {
    if (content) {
      return content;
    }
    if (contentText) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, numberBadgeAmount ? /*#__PURE__*/React.createElement(Badge, {
        number: numberBadgeAmount,
        size: "medium"
      }) : null, /*#__PURE__*/React.createElement(S.ContentText, {
        $size: size
      }, contentText));
    }
    return null;
  };
  const handleActionFocus = () => {
    if (!readOnly) {
      setIsActionFocused(true);
    }
  };
  const handleActionBlur = () => {
    setIsActionFocused(false);
  };
  const handleDismissKeyUp = e => {
    if (e.code === 'Space') {
      setIsDismissActive(false);
    }
    if (e.code === 'Enter' && onDismiss) {
      onDismiss(value, e);
    }
  };
  const handleDismissKeyDown = e => {
    if (e.code === 'Space') {
      setIsDismissActive(true);
    }
  };
  const handleDismiss = e => {
    if (onDismiss) {
      onDismiss(value, e);
    }
  };
  return /*#__PURE__*/React.createElement(S.SelectableTagContainer, {
    "aria-disabled": disabled,
    ref: containerRef,
    $isFocused: isActionFocused,
    $size: size,
    $readOnly: readOnly,
    $disabled: disabled
  }, /*#__PURE__*/React.createElement(S.ActionButton, _extends({
    "aria-label": ariaLabel,
    ref: ref,
    tabIndex: readOnly ? -1 : 1,
    onFocus: handleActionFocus,
    onBlur: handleActionBlur,
    role: "button",
    $disabled: disabled,
    $size: size,
    $readOnly: readOnly,
    $dismissable: dismissable,
    $isDismissHover: isDismissHover,
    $isDismissActive: isDismissActive
  }, props), renderContent()), dismissable ? /*#__PURE__*/React.createElement(S.DismissButton, {
    onMouseEnter: () => setIsDismissHover(true),
    onMouseLeave: () => setIsDismissHover(false),
    onPointerDown: () => setIsDismissActive(true),
    onPointerUp: () => setIsDismissActive(false),
    onKeyUp: handleDismissKeyUp,
    onKeyDown: handleDismissKeyDown,
    onClick: handleDismiss,
    role: "button",
    tabIndex: 0,
    $disabled: disabled,
    $size: size,
    $readOnly: readOnly
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    size: "medium",
    variant: "bold"
  })) : null);
});
export { Tag };